<template>
  <SelectExpertApply-form/>
</template>

<script>

import SelectExpertApplyForm from '@/epp/expertmain/selectexpertapply/common/SelectExpertApplyForm'

export default {
  name: 'SelectExpertApplyAdd',
  components: {
    SelectExpertApplyForm
  },
  data () {
    return {}
  },
  computed: {},
  created () {
  },
  methods: {}
}
</script>

<style></style>
